export default "__VITE_ASSET__BM86yV4n__"